/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Edit_User_Permissions_TitleInputs */



/**
* | output |
* | --- |
* | "Edit User Permissions" |
*
* @param {Spaces_Edit_User_Permissions_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_edit_user_permissions_title = /** @type {((inputs?: Spaces_Edit_User_Permissions_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Edit_User_Permissions_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerberechtigungen bearbeiten")
	return /** @type {LocalizedString} */ ("Edit User Permissions")
});